import { getBaseUrl } from "~/lib/utils";

const DEFAULT_SITE_NAME = "Locationguide24";
const DEFAULT_OG_IMAGE = "/og-default.jpg";

export const seo = ({
  title,
  description,
  keywords,
  image,
  url,
  siteName = DEFAULT_SITE_NAME,
  locale = "de_DE",
  type = "website",
  twitterCreator,
  twitterSite,
}: {
  title: string;
  description?: string;
  image?: string;
  keywords?: string;
  url?: string;
  siteName?: string;
  locale?: string;
  type?: "website" | "article";
  twitterCreator?: string;
  twitterSite?: string;
}) => {
  const baseUrl = getBaseUrl();
  const resolvedImage =
    image ?? (baseUrl ? `${baseUrl}${DEFAULT_OG_IMAGE}` : undefined);
  const resolvedUrl = url ?? (baseUrl ? baseUrl : undefined);

  const tags: Array<
    | { title: string }
    | { name: string; content: string }
    | { property: string; content: string }
  > = [
    { title },
    ...(description
      ? [{ name: "description" as const, content: description }]
      : []),
    ...(keywords ? [{ name: "keywords" as const, content: keywords }] : []),
    // Open Graph (use property)
    { property: "og:type", content: type },
    { property: "og:title", content: title },
    ...(description
      ? [{ property: "og:description" as const, content: description }]
      : []),
    ...(resolvedUrl
      ? [{ property: "og:url" as const, content: resolvedUrl }]
      : []),
    { property: "og:site_name", content: siteName },
    ...(locale ? [{ property: "og:locale" as const, content: locale }] : []),
    ...(resolvedImage
      ? [{ property: "og:image" as const, content: resolvedImage }]
      : []),
    // Twitter Card
    {
      name: "twitter:card",
      content: resolvedImage ? "summary_large_image" : "summary",
    },
    { name: "twitter:title", content: title },
    ...(description
      ? [{ name: "twitter:description" as const, content: description }]
      : []),
    ...(resolvedImage
      ? [{ name: "twitter:image" as const, content: resolvedImage }]
      : []),
    ...(twitterCreator
      ? [{ name: "twitter:creator" as const, content: twitterCreator }]
      : []),
    ...(twitterSite
      ? [{ name: "twitter:site" as const, content: twitterSite }]
      : []),
  ];

  return tags;
};
